import styled from "styled-components";
import { IoArrowBackOutline } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";

export const Background = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border-top: 1px solid #f0f0fa;
  box-sizing: border-box;

  @page {
    size: landscape;
    margin: 0;
  }

  @media print {
    width: 100%;
    height: 100%;
  }
`;

export const Page = styled.div`
  height: 297mm;
  width: 210mm;
  padding: 5mm;
  margin: 10mm auto;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

  .grid-layout {
    display: grid;
    grid-template-columns: repeat(2, 20rem);
    grid-template-rows: repeat(2, 35rem);
    gap: 5px; /* Reduz espaço vertical */
    justify-content: center;
    align-self: start; /* Evita espaços desnecessários */
    align-content: start; /* Evita espaços desnecessários */
    align-content: start; /* Evita espaços desnecessários */
  }

  .globalMobilepdf {
    transform: scaleX(0.8) scaleY(0.7);
    transform-origin: top left;
  }

  .quadrosMobilepdf{
    margin-top: 50px;
  }

  .namesMobilepdf {
    height: 4rem;
  }

  @media print {
    margin: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
    background: transparent;
  }
`;

export const IconBack = styled(IoArrowBackOutline)`
  position: fixed;
  top: 100px;
  left: 50px;
  font-size: 50px;
  cursor: pointer;
  transition: 0.25s;
  z-index: 1000;

  &:hover {
    color: #3587d1;
    transform: translateX(-5px);
  }

  @media print {
    display: none;
  }
`;

export const IconDownload = styled(FiDownload)`
  position: fixed;
  top: 100px;
  right: 50px;
  font-size: 50px;
  cursor: pointer;
  transition: 0.25s;
  z-index: 1000;

  &:hover {
    color: #3587d1;
    transform: translateY(5px);
  }

  @media (max-width: 768px) {
    right: none;
    left: 50px;
    top: 150px;
  }

  @media print {
    display: none;
  }
`;
